import { Injectable, ErrorHandler, Injector, Inject } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { AuthService } from "./auth.service";
import { LoginPage } from "../../pages/login.page/login.page";
import { ENV_VARS } from "../environment-variables/environment-variables.module";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private ravenErrorHandler: ErrorHandler,
    private inj: Injector,
    @Inject(ENV_VARS) public envVars
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).catch(err => {
      if (this.envVars.ENABLE_SENTRY === "YES") {
        this.ravenErrorHandler.handleError(JSON.stringify(err));
      }
      console.log(err);
      if (err instanceof HttpErrorResponse) {
        if (
          err.status === 401 &&
          err.error.error === undefined &&
          err.error.error.type !== "Invalid credentials"
        ) {
          // {message: "Wrong login and/or password.", type: "Invalid credentials"} is returned if wrong login credentials
          // JWT expired, go to login
          const auth: AuthService = this.inj.get(AuthService);
          auth.navCtrl.setRoot(LoginPage);
        }
      }
      return Observable.throw(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/error.interceptor.ts